var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"proDetails"},_vm._l((_vm.infoData),function(item,index){return _c('div',{staticClass:"fw",domProps:{"innerHTML":_vm._s(item.ProductDesc)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }